// layouts/catalogos/parametros/datosparametros.js

/* eslint-disable react/prop-types */
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { ui } from "ui/tokens";

export const columns = [
  { name: "formato", align: "left", sortable: true },
  { name: "vigencia", align: "center", sortable: true },
  { name: "oro", align: "right", sortable: true },
  { name: "platino", align: "right", sortable: true },
  { name: "diamante", align: "right", sortable: true },
  { name: "acciones", align: "center" },
];

function fmtDate(d) {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return String(d);
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yy = String(dt.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  } catch {
    return String(d);
  }
}

export default function buildParametrosTableData(items = [], map) {
  const rows = (items || []).map((it, idx) => {
    const r =
      typeof map === "function"
        ? map(it, idx)
        : {
            id: it.id ?? it._id ?? idx,
            format: it.format ?? "—",
            since: it.since,
            until: it.until,
            gold: it.gold,
            platinum: it.platinum,
            diamond: it.diamond,
            onEdit: () => {},
            onDelete: () => {},
          };

    return {
      formato: (
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography variant="button" fontWeight="medium">
            {r.format ?? "—"}
          </SoftTypography>
        </SoftBox>
      ),

      vigencia: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {fmtDate(r.since)} — {fmtDate(r.until)}
        </SoftTypography>
      ),

      oro: (
        <SoftTypography variant="button" fontWeight="medium">
          {r.gold != null ? r.gold : "—"}
        </SoftTypography>
      ),

      platino: (
        <SoftTypography variant="button" fontWeight="medium">
          {r.platinum != null ? r.platinum : "—"}
        </SoftTypography>
      ),

      diamante: (
        <SoftTypography variant="button" fontWeight="medium">
          {r.diamond != null ? r.diamond : "—"}
        </SoftTypography>
      ),

      acciones: (
        <SoftBox display="flex" justifyContent="center" gap={0.5}>
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={(e) => {
                e.preventDefault();
                r.onEdit?.(r);
              }}
              sx={{
                "& .icon-edit": { color: ui.icon?.edit?.base || "#0ea5e9" },
                "&:hover .icon-edit": { color: ui.icon?.edit?.hover || "#0284c7" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-edit" fontSize="small">
                edit
              </Icon>
            </IconButton>
          </Tooltip>

          <Tooltip title="Eliminar">
            <IconButton
              size="small"
              onClick={(e) => {
                e.preventDefault();
                r.onDelete?.(r);
              }}
              sx={{
                "& .icon-del": { color: ui.icon?.del?.base || "#ef4444" },
                "&:hover .icon-del": { color: ui.icon?.del?.hover || "#b91c1c" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-del" fontSize="small">
                delete
              </Icon>
            </IconButton>
          </Tooltip>
        </SoftBox>
      ),
    };
  });

  return { columns, rows };
}
